import type React from "react";
import { forwardRef } from "react";
import "./IconButton.scss";

export type IconSize = "medium" | "large";

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  iconName?: string;
  svgIcon?: React.ReactNode;
  ariaLabel: string;
  isActive?: boolean;
  className?: string;
  size?: IconSize; // TODO: Standardize sizes
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ iconName, svgIcon, ariaLabel, isActive, className = "", onClick, size = "medium", children, ...props }, ref) => {
    const buttonClass = "icon-button2";
    const activeClass = isActive ? `${buttonClass}--active` : "";
    const sizeClass = size !== "medium" ? `${buttonClass}--${size}` : "";

    return (
      <button
        ref={ref}
        className={`icon-button2 ${activeClass} ${sizeClass} ${className}`}
        type="button"
        aria-label={ariaLabel}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
        }}
        {...props}
      >
        {svgIcon ? svgIcon : <span className="material-icons">{iconName}</span>}
        {children}
      </button>
    );
  },
);
IconButton.displayName = "IconButton";
